import actionTypes from './GSMBIBIO01ActionType';

/**
 * 請求情報出力
 */
const initialState = {
    isFetching: false,
    data: {},
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 請求情報一覧照会を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getRequestInfoList = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REQUEST_INFO_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_REQUEST_INFO_LIST_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_REQUEST_INFO_LIST_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_REQUEST_INFO_LIST_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 請求情報ファイルを作成Reducer
 * @param {*} state
 * @param {*} action
 */
export const creatRequestInfoFile = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CREAT_REQUEST_INFO_FILE_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.CREAT_REQUEST_INFO_FILE_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.CREAT_REQUEST_INFO_FILE_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.CREAT_REQUEST_INFO_FILE_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 請求情報ファイルをダウンロードReducer
 * @param {*} state
 * @param {*} action
 */
export const downloadRequestInfoFile = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DOWNLOAD_REQUEST_INFO_FILE_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.DOWNLOAD_REQUEST_INFO_FILE_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data,
                isError: false,
                err_type: action.data.err_type == null ? "200" : action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.DOWNLOAD_REQUEST_INFO_FILE_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.DOWNLOAD_REQUEST_INFO_FILE_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
